module.exports = __webpack_public_path__ + "media/stylesheets/images/main/sample_360-6b4ff43aa568199eb44460df5b5504e6.png";